const HEIC_EXTENSIONS = ['heic', 'heif'];
const HEIC_MIME_TYPES = ['image/heic', 'image/heif'];

export const replaceExtension = (fileName: string, extension: string) => `${fileName.replace(/\.[^.]+$/, '')}.${extension}`;

export const isHeicFile = (file: File) =>
	HEIC_EXTENSIONS.includes(file.name.split('.').pop()?.toLowerCase() ?? '') || HEIC_MIME_TYPES.includes(file.type);

export async function toUploadableImageFile(file: File): Promise<File> {
	if (!isHeicFile(file)) return file;

	const { heicTo } = await import('heic-to');
	const jpeg = await heicTo({ blob: file, quality: 0.9, type: 'image/jpeg' });

	return new File([jpeg], replaceExtension(file.name, 'jpg'), { lastModified: file.lastModified, type: 'image/jpeg' });
}
